import { Component, Input, OnDestroy } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Subject } from 'rxjs';
import { ISpecificBrickSettingsComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';

@Component({
   selector: 'samweb-toolbar-brick-settings',
   templateUrl: './toolbar-brick-settings.component.html',
   styleUrls: ['./toolbar-brick-settings.component.scss'],
})
export class ToolbarBrickSettingsComponent implements OnDestroy, ISpecificBrickSettingsComponent {
   @Input()
   public brickInstanceId: string;

   public addTabIcon: IconDefinition = faPlus;

   private destroy$ = new Subject();

   constructor() {}

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
